// const url = "/api/assurance.json";
const url = "https://olaw.nih.gov/api/assurance.json";
export default url;